import * as Yup from "yup";

export const getTagValidationSchema = () =>
  Yup.object({
    name: Yup.string()
      .trim()
      .min(2, "Tag name must be at least 2 characters")
      .required("Tag name is required"),

    slug: Yup.string()
      .trim()
      .matches(
        /^[a-z0-9-]+$/,
        "Slug must contain lowercase letters, numbers and hyphens only",
      )
      .required("Slug is required"),
  });

export const tagValidationSchema = getTagValidationSchema();
